import React from "react";
import moment from "moment";
import { Link } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import LedgerActions from "../../../actions/LedgerActions";
import LedgerStore from "../../../stores/LedgerStore";
import { formatPrice, capitalize, unSnakeCase } from "../../../util.js";

import GenericAnalyticsTable from "../generic-analytics-table.jsx";

class LedgerTable extends React.Component {
  constructor(props) {
    super(props);
  }

  static getStores() {
    return [LedgerStore];
  }

  static getPropsFromStores() {
    return {
      getLedgerTransactionsForOrder: LedgerStore.getLedgerTransactionsForOrder
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  componentDidMount() {
    if (this.props.orderId) {
      LedgerActions.fetchLedgerTransactionsForOrder.defer(this.props.orderId);
    }
  }

  getStyles() {
    return {};
  }

  render() {
    const styles = this.getStyles();

    const transactions = this.props.orderId
      ? this.props.getLedgerTransactionsForOrder(this.props.orderId)
      : [];

    return (
      <GenericAnalyticsTable
        csvLabel="ledger-activity"
        csvLabelDetail={`${this.props.orderId}-${Date.now()}`}
        // noSort
        // noDownload
        // loading={this.props.loading}
        // loadingStyle={{ padding: 10 }}
        data={transactions.map(transaction => {
          return {
            date: {
              value: transaction.date,
              label: (
                <span style={{ whiteSpace: "nowrap" }}>
                  {moment(transaction.date).format("lll")}
                </span>
              )
            },
            account: capitalize(unSnakeCase(transaction.balance_account.type)),
            currency: transaction.currency,
            type: {
              value: transaction.type,
              label: (
                <span style={{ whiteSpace: "nowrap" }}>
                  {capitalize(unSnakeCase(transaction.type))}
                </span>
              )
            },
            reason:
              transaction.reason === "revenue_sharing"
                ? `Revenue sharing with ${transaction.revenue_share_affiliate.ref_label}`
                : transaction.reason === "revenue_sharing_refund"
                ? `Revenue sharing refund with ${transaction.revenue_share_affiliate.ref_label}`
                : capitalize(unSnakeCase(transaction.reason)),
            class: capitalize(unSnakeCase(transaction.class)),
            category: transaction.category
              ? transaction.category.ref_label
              : undefined,
            subcategory: transaction.subcategory
              ? transaction.subcategory.ref_label
              : undefined,
            variant: transaction.variant
              ? transaction.variant.ref_label
              : undefined,
            gross: {
              value: transaction.gross,
              label: formatPrice(transaction.gross, {
                currency: transaction.currency,
                accounting: true
              })
            },
            fee: {
              value: -transaction.fee,
              label: formatPrice(-transaction.fee, {
                currency: transaction.currency,
                accounting: true
              })
            },
            net: {
              value: transaction.net,
              csv_label: formatPrice(transaction.net, {
                currency: transaction.currency,
                accounting: true
              }),
              label: (
                <span style={{ fontWeight: "bold" }}>
                  {formatPrice(transaction.net, {
                    currency: transaction.currency,
                    accounting: true
                  })}
                </span>
              )
            },
            actions: {
              value: 1,
              label: (
                <span style={{ whiteSpace: "nowrap" }}>
                  {transaction.order ? (
                    <Link to={`/orders/${transaction.order}`} target="_blank">
                      View order
                    </Link>
                  ) : null}
                </span>
              )
            }
          };
        })}
        columns={[
          { label: "Date", value: "date" },
          { label: "Account", value: "account" },
          { label: "Type", value: "type" },
          { label: "Reason", value: "reason" },
          { label: "Class", value: "class" },
          { label: "Category", value: "category" },
          { label: "Subcategory", value: "subcategory" },
          transactions.some(t => !!t.variant) && {
            label: "Variant",
            value: "variant"
          },
          { label: "Gross", value: "gross" },
          { label: "Fee", value: "fee" },
          { label: "Net", value: "net" },
          !this.props.orderId && { label: "Actions", value: "actions" }
        ].filter(x => !!x)}
      />
    );
  }
}

export default connectToStores(LedgerTable);



// WEBPACK FOOTER //
// ./src/app/components/partials/ledger/ledger-table.jsx